<template>
  <v-container>
    <v-alert class="mt-8" icon="mdi-information" prominent text type="info">
      <v-row align="center">
        <v-col class="grow">
          Unggah berkas dan pilih sasaran sesuai Seri yang akan Anda ikuti
        </v-col>
        <v-col class="shrink">
          <v-btn class="info" @click="toInstansi">Halaman Seri</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <m-card-list
      title="Berkas"
      id-key
      filter
      search
      add
      @add="add"
      :variablePencarian="[{ key: 'Nama', value: 'nama' }]"
      @refresh="load"
      :items="items"
      footerLabel="Berkas"
      @search="
        search => {
          dataPencarian = search;
          load();
        }
      "
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      footer
    >
      <template v-slot:items="{ item }">
        <v-row class="mx-6 my-2">
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 12 : 10" sm="9" md="9" lg="10" xl="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="6" xl="6">
                <v-row align="center" class="d-flex align-center">
                  <!-- Ikon File -->
                  <v-avatar :size="35" color="primary lighten-3">
                    <v-icon size="20" color="white">mdi-file</v-icon>
                  </v-avatar>
                  <v-col cols="auto">
                    <span class="caption grey--text">Nama Berkas</span>
                    <p class="py-0 my-0">{{ pVal(item, "nama_berkas") }}</p>
                    <p class="font-weight-medium my-0 py-0" v-if="item.sasaran.length > 0">
                      <v-icon small color="blue">mdi-file</v-icon><a :href="item.sasaran[0].url" target="_blank" class="text-caption">File Berkas</a>
                    </p>
                    <p class="font-weight-medium my-0 py-0 error--text" v-else>
                      Berkas tidak tersedia
                    </p>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <span class="caption grey--text">Jenis Berkas</span>
                <p class="font-weight-medium my-0 py-0">{{ pVal(item.jenis_berkas, "keterangan") }}</p>
              </v-col>

              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <span class="caption grey--text">Sasaran</span>
                <p class="font-weight-medium my-0 py-0">{{ item.sasaran.map(s => s.instansi.nama).join(", ") }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1" xl="1">
            <m-menu left style="float: right" :items="more_menu" :object="item" />
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>

    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import ChangeDlg from "../../user/components/FormBerkas.vue";

export default {
  components: {
    ChangeDlg
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o)
        }
      ],

      dataPencarian: null,

      jenisBerkases: [],
      selectedFileType: "",
      selectedFile: null,
      berkas: null,
      listBerkases: [],
      editingIndex: null
    };
  },

  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    isValidForm() {
      return this.selectedFileType !== "" && this.selectedFile !== null;
    },
    isEditing() {
      return this.editingIndex !== null;
    }
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      var params = {};
      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }

      return this.$store
        .dispatch("user/getBerkas", { params: params })
        .then(res => {
          this.listBerkases = res.data;
          this.jenisBerkases = res.jenis_berkas;
          this.berkas = res;

          this.items = res.data;
        })
        .catch(e => {
          throw e; // Rethrow the error to handle it further if needed
        });
    },

    toInstansi() {
      this.$router.push({ name: "instansi.pilih" });
    },

    add() {
      this.$refs.dlg.open(this.jenisBerkases, this.berkas).then(() => {
        this.load();
      });
    },

    edit(item) {
      this.$refs.dlg.open(this.jenisBerkases, this.berkas, item).then(() => {
        this.load();
      });
    },

    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus berkas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.jenis_berkas.keterangan}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("user/berkasDrop", item))
        .then(() => {
          this.$info("Berkas " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
